import React from 'react';
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import HomeListStore from './pages/storeList';
import StoreMenuPage from './pages/storeMenuPage';

// A simple theme for the application
const theme = createTheme({
  palette: {
    background: {
      default: '#f4f6f8',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});

// --- Main Application Component ---
export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeListStore />} />
          <Route path="/:storeId" element={<StoreMenuPage />} />
          {/* A catch-all for any other path redirects to the home page */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
